import APIClient from '@/shared/http/clients/api'

const resourceName = 'contratos-vigentes'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)

/**
 * @name ContratosVigentesRepository
 * @description Captação Remunerada Diária
 * @type { Respository }
 */
const ContratosVigentesRepository = {
  Search
}

export default ContratosVigentesRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/contratosvigentes.js